<div class="flex w-full gap-2.5 bg-gray-000 p-3">
	<ui-button
		class="min-w-0 flex-1"
		variant="green"
		model="outline"
		size="lg"
		label="خرید"
		extraButtonClasses="w-full !border-2 !font-bold enabled:hover:!border-green-500 enabled:hover:!bg-green-500 enabled:hover:!text-white enabled:active:!border-green-700 enabled:active:!bg-green-700 enabled:active:!text-white"
		data-testid="buy-button"
		[disabled]="buyDisabled()"
		[routerLink]="buyDisabled() ? null : ['/order-form', isin(), OrderSide.Buy]" />
	<ui-button
		class="min-w-0 flex-1"
		variant="red"
		model="outline"
		size="lg"
		label="فروش"
		extraButtonClasses="w-full !border-2 !font-bold enabled:hover:!border-red-500 enabled:hover:!bg-red-500 enabled:hover:!text-white enabled:active:!border-red-700 enabled:active:!bg-red-700 enabled:active:!text-white"
		data-testid="sell-button"
		[disabled]="sellDisabled()"
		[routerLink]="sellDisabled() ? null : ['/order-form', isin(), OrderSide.Sell]" />
</div>
